import { Routes } from '@angular/router';

import {
  AdminGuard,
  AuthAllGuard,
  AuthAuthorizedGuard,
  AuthUnauthorizedGuard,
  ForceUserToSetOrganisationTypeGuard,
  NatureReportingGuard,
} from '@core/store';
import { ExpiredInvitationPageErrorComponent, PageNotFoundComponent } from '@shared/errors';

import { FarmerNatureReportingGuard } from './map/guards/farmer-nature-reporting.guard';
import { MarketingUpgradeEntryPageComponent } from './marketing-upgrade-entry-page/marketing-upgrade-entry-page.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: '/maps', pathMatch: 'full' },
  {
    path: 'account/subscription/upgrade/direct',
    canActivate: [AuthAllGuard],
    component: MarketingUpgradeEntryPageComponent,
  },
  {
    path: 'internal-login',
    loadChildren: () => import('./auth-internal/auth-internal.routes').then((m) => m.authInternalRoutes),
  },
  {
    path: 'register',
    canActivate: [AuthUnauthorizedGuard],
    loadChildren: () => import('./register/register.routes').then((m) => m.registerRoutes),
  },
  {
    path: 'login',
    canActivate: [AuthUnauthorizedGuard],
    loadChildren: () => import('./login/login.routes').then((m) => m.loginRoutes),
  },
  {
    path: 'logged-out',
    loadChildren: () => import('./logout/logout.routes').then((m) => m.logoutRoutes),
  },
  {
    path: 'forgot-password',
    canActivate: [AuthUnauthorizedGuard],
    loadChildren: () => import('./forgot-password/forgot-password.routes').then((m) => m.forgotPasswordRoutes),
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.routes').then((m) => m.usersRoutes),
  },
  {
    path: 'account',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./account/account.routes').then((m) => m.accountRoutes),
  },
  {
    path: 'maps',
    canActivate: [AuthAuthorizedGuard, ForceUserToSetOrganisationTypeGuard],
    loadChildren: () => import('./maps/maps.routes').then((m) => m.mapsRoutes),
  },
  {
    path: 'map',
    canActivate: [AuthAuthorizedGuard, ForceUserToSetOrganisationTypeGuard],
    loadChildren: () => import('./map/map.routes').then((m) => m.mapRoutes),
  },
  {
    path: 'map/:mapId/nature-reporting',
    canActivate: [AuthAuthorizedGuard, FarmerNatureReportingGuard],
    loadChildren: () => import('./farmer-nature-reporting/farmer-nature-reporting.routes').then((m) => m.farmerNatureReportingRoutes),
  },
  {
    path: 'prints',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./prints/prints.routes').then((m) => m.printsRoutes),
  },
  {
    path: 'print-customization',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./print/print.routes').then((m) => m.printRoutes),
  },
  {
    path: 'referrals',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./referrals/referrals.routes').then((m) => m.referralsRoutes),
  },
  {
    path: 'data-purchases',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./data-purchases/data-purchases.routes').then((m) => m.dataPurchasesRoutes),
  },
  {
    path: 'reports',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./reports/reports.routes').then((m) => m.reportsRoutes),
  },
  {
    path: 'admin',
    canActivate: [AuthAuthorizedGuard, AdminGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'nature-reporting',
    canActivate: [AuthAuthorizedGuard, NatureReportingGuard],
    loadChildren: () => import('./nature-reporting/nature-reporting.routes').then((m) => m.natureReportingRoutes),
  },
  {
    path: 'title-purchases',
    canActivate: [AuthAuthorizedGuard],
    loadChildren: () => import('./title-purchases/title-purchases.routes').then((m) => m.titlePurchasesRoutes),
  },
  {
    path: 'organisation/invitations',
    component: ExpiredInvitationPageErrorComponent,
  },
  { path: '**', component: PageNotFoundComponent },
];
